import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { trigger, transition, style, animate, state, AnimationEvent } from '@angular/animations';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
interface BadgeAttributes {
  value: string | number;
  backgroundColor?: string;
  color?: string;
}

@Component({
    selector: 'topo-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    standalone: false
})
export class TabsComponent implements OnInit {
  isCautionShown: any;

  @Input() center = false;
  @Input()
  public set margin(value) {
    this.marginStyle = { width: `${value}rem` };
  }
  @Input() selectedTabIndex = 0;
  @Input() tabs: string[] = [];
  @Input() icons: string[];
  // @Input() iscautionicons: Set;
  get iscautionicons(): boolean {
    return this.isCautionShown;
  }
  @Input() set iscautionicons(value: boolean) {
    this.isCautionShown = value;
  }

  @Input() disabledTabs: number[] = [];
  @Input() isMobile: boolean;
  @Input() fillSpace = true;
  @Input() tabCssClass: string;
  @Output() selectedTabIndexChanged = new EventEmitter<number>();
  @Input() tabBadgeMap: { [key: number]: BadgeAttributes } = {};
  marginStyle: any = null;

  constructor(private translateService: TranslateService) {}
  ngOnInit() {}
  tabClick(index): void {
    if (this.disabledTabs?.findIndex(dt => dt === index) >= 0) {
      return;
    }

    this.selectedTabIndex = index;
    this.selectedTabIndexChanged.emit(this.selectedTabIndex);
  }

  isDisabled(index: number) {
    return this.disabledTabs?.findIndex(dt => dt === index) >= 0;
  }
  getTabSmsType() {
    return this.translateService.instant('COMMUNICATIONS.TAB-SMS-TYPE');
  }
  getTabMsgType() {
    return this.translateService.instant('COMMUNICATIONS.TAB-MESSAGE');
  }

  getIcon(index: number): string {
    if (!!this.icons && this.icons.length > index) {
      return this.icons[index];
    }
    return null;
  }

  getBadge(index: number): BadgeAttributes {
    const badge = this.tabBadgeMap[index] ?? null;
    return badge;
  }

  onAnimationEvent(event: AnimationEvent) {}
}
